export default {
  // Navigation
  'nav.timer': '计时器',
  'nav.stopwatch': '秒表',
  'nav.worldclock': '世界时钟',
  'nav.timestamp': '时间戳',
  'nav.home': '首页',
  
  // Common buttons and actions
  'button.start': '开始',
  'button.pause': '暂停',
  'button.stop': '停止',
  'button.reset': '重置',
  'button.ok': '确定',
  'button.cancel': '取消',
  'button.close': '关闭',
  'button.save': '保存',
  'button.delete': '删除',
  'button.edit': '编辑',
  'button.back': '返回',
  'button.next': '下一步',
  'button.previous': '上一步',
  'button.submit': '提交',
  'button.confirm': '确认',
  'button.convert': '转换',
  'button.copy': '复制',
  'button.copied': '已复制！',
  'button.now': '当前时间',
  'button.clear': '清空',
  
  // Common labels
  'label.hours': '小时',
  'label.minutes': '分钟',
  'label.seconds': '秒钟',
  'label.milliseconds': '毫秒',
  'label.minute': '分钟',
  'label.second': '秒',
  'label.sound': '声音',
  'label.soundAlert': '声音',
  'label.fullscreen': '全屏',
  'label.language': '语言',
  'label.selectLanguage': '选择语言',
  'label.languageSelectorInfo': '目前支持 {{count}} 种语言。从上方选项中选择您偏好的语言。',
  
  // Common messages
  'message.timerComplete': '计时完成！',
  'message.timerCompleteDesc': '您的计时器已完成',
  'message.timerCompleteBody': '您的倒计时已完成！',
  'message.stopwatchStarted': '秒表已开始',
  'message.stopwatchStartedDesc': '秒表计时已开始',
  'message.stopwatchStopped': '秒表已暂停',
  'message.stopwatchStoppedDesc': '秒表计时已暂停',
  'message.stopwatchReset': '秒表已重置',
  'message.stopwatchResetDesc': '秒表已重置为零',
  'message.notificationPermission': '允许通知以在计时器完成时获得提醒',
  'message.clickToEdit': '点击时间数字可直接编辑时间',
  'message.addHours': '+ 添加小时',
  'message.escToExit': '按ESC退出全屏',
  'message.timeRemaining': '剩余{{minutes}}分{{seconds}}秒',
  'message.minutesRemaining': '剩余{{minutes}}分钟',
  'message.secondsRemaining': '剩余{{seconds}}秒',
  'message.stopwatchTimeElapsed': '已过{{minutes}}分{{seconds}}秒',
  'message.stopwatchMinutesElapsed': '已过{{minutes}}分钟',
  'message.stopwatchSecondsElapsed': '已过{{seconds}}秒',
  'message.invalidTimestamp': '无效的时间戳',
  'message.invalidDateTime': '无效的日期时间',
  'message.conversionError': '转换错误',
  
  // Time units
  'time.am': '上午',
  'time.pm': '下午',
  'time.now': '现在',
  'time.today': '今天',
  'time.yesterday': '昨天',
  'time.tomorrow': '明天',
  
  // Common errors
  'error.pageNotFound': '页面未找到',
  'error.somethingWrong': '出现了问题',
  'error.tryAgain': '请稍后重试',
  
  // Footer
  'footer.about': '关于 timer.today',
  'footer.aboutDesc': 'timer.today 是一个专业的在线计时工具平台，提供三个核心功能：',
  'footer.timerDesc': '可自定义的倒计时工具，支持分钟和小时设置，适用于工作专注、烹饪计时、学习管理等。具有声音提醒和桌面通知功能。',
  'footer.stopwatchDesc': '高精度计时工具，具有毫秒级精度，适用于运动训练、烹饪操作、考试练习等需要精确计时的场景。',
  'footer.worldClockDesc': '实时显示全球主要城市时间，智能时区计算，便于国际商务沟通和跨时区协作。',
  'footer.timestampDesc': 'Unix时间戳转换器，支持时间戳与日期时间的双向转换，支持秒级和毫秒级两种格式。',
  'footer.termsOfService': '服务条款',
  'footer.privacy': '隐私政策',
  'footer.contactUs': '联系我们',
  'footer.changeLanguage': '切换语言',
  'footer.moreLanguage': '更多语言',
  'footer.copyright': '© timer.today 2024',
  
  // Quick actions
  'quick.add30s': '+30秒',
  'quick.add1min': '+1分钟',
  'quick.add5min': '+5分钟',
  'quick.add10min': '+10分钟',
  'quick.add30min': '+30分钟',
  
  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}}分钟计时器',
  'breadcrumb.timer': '计时器',
  'breadcrumb.stopwatch': '秒表',
  'breadcrumb.worldClock': '世界时钟',
  'breadcrumb.termsOfService': '服务条款',
};